import './supTicketsDetails.css';
import detailedData from '../../../dummyData/tickets.json';
import { ReactComponent as Message } from '../../../assets/icons/trvto_message.svg';
import { ReactComponent as Refund } from '../../../assets/icons/trvto_refund.svg';
import { ReactComponent as CloseTicket } from '../../../assets/icons/trvto_closeTicket.svg';
import { ReactComponent as CancelBooking } from '../../../assets/icons/trvto_cancelBooking.svg';
import MoreItem from './moreItem';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    addComment,
    fetchTicketById,
    getUsers,
    sendMessage,
    updateAssignee,
    updateTicket
} from '../ticketsFunctions/fetchTicketsInfo';
import ReactLoading from 'react-loading';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import Dialog from '../../../components/dialogModal/dialogModal';
import EditIcon from '../../../assets/icons/trvto_edit_icon.svg';

const SupTicketsDetails = () => {
    const ticketId = useParams();
    const navigate = useNavigate();
    const [ticketData, setTicketData] = useState({});
    const [loading, setLoading] = useState([]);
    const [load, setLoad] = useState(false);
    const [comment, setComment] = useState('');
    const [commentModal, setCommentModal] = useState(false);
    const [description, setDescription] = useState('');
    const [descModal, setDescModal] = useState(false);
    const [assignedUser, setAssignedUser] = useState('');
    const [userList, setUserList] = useState([]);
    const [assignModal, setAssignModal] = useState(false);
    const refresh = () => {
        setLoad(!load);
    };
    const data = detailedData.data[0];
    useEffect(() => {
        if (!ticketId.id) return;
        fetchTicketById(setLoading, setTicketData, ticketId.id, setAssignedUser);
    }, [ticketId, load]);

    useEffect(() => {
        if (!assignModal) return;
        getUsers(setUserList, setLoading);
    }, [assignModal]);

    const handleSendMessage = () => {
        sendMessage(ticketData.type, ticketData.bookingId._id, setLoading);
    };

    const handleUpdateTicket = (actionType) => {
        let ticketStatus;
        if (actionType === 'open') ticketStatus = 'in_progress';
        else if (actionType === 'close') ticketStatus = 'resolved';
        else ticketStatus = ticketData.status;
        const data = {
            status: ticketStatus,
            description: description ?? ticketData.description
        };
        updateTicket(
            ticketData.type,
            ticketData._id,
            data,
            setDescription,
            setDescModal,
            setLoading,
            actionType,
            refresh
        );
    };

    const submitComment = () => {
        const data = {
            comment: comment,
            name: localStorage.getItem('supName'),
            by: localStorage.getItem('supId'),
            at: new Date()
        };
        addComment(ticketData.type, ticketData._id, data, setComment, setLoading, refresh);
    };

    const handleAssigneeUpdate = () => {
        const data = {
            assignedTo: assignedUser
        };
        updateAssignee(ticketData.type, ticketData._id, data, setAssignedUser, setAssignModal, setLoading, refresh);
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                Back to Tickets
            </button>
            {ticketData && (
                <div className='supportDetailsContainer'>
                    <h2>{ticketData?.userId?.name}</h2>
                    <div className='infoContainer'>
                        <div className='infoDetail'>
                            <p className='infoLabel'>Ticket ID:</p>
                            <p className='infoValue'>{ticketData?._id}</p>
                        </div>
                        <div className='infoDetail'>
                            <p className='infoLabel'>Customer ID:</p>
                            <p className='infoValue'>{ticketData?.userId?._id}</p>
                        </div>
                        <div className='infoDetail'>
                            <p className='infoLabel'>Type:</p>
                            <p className='infoValue'>{ticketData?.type}</p>
                        </div>
                        <div className='infoDetail'>
                            <p className='infoLabel'>Time of Booked:</p>
                            <p className='infoValue'>{data.bookingTime}</p>
                        </div>
                        <div className='infoDetail'>
                            <p className='infoLabel'>Organizer Name:</p>
                            <p className='infoValue'>{ticketData?.packId?.organizerName}</p>
                        </div>
                    </div>
                    <div className='supportDivider' />
                    <div className='supportTicketDetails'>
                        <div>
                            <div className='descHeader'>
                                <h4>Description</h4>
                                <button className='org_tripEdit' onClick={() => setDescModal(true)}>
                                    <img src={EditIcon} alt='edit' />
                                </button>
                            </div>
                            <p>{ticketData.description}</p>
                            <div className='blogComments borderNone'>
                                <h3>Add Comment</h3>
                                <div className='commentForm'>
                                    <textarea
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder='Write your comment...'
                                    />
                                    <div className='commentButtons'>
                                        {ticketData?.comments?.length > 0 && (
                                            <button
                                                className='blueBtn mr-2'
                                                type='submit'
                                                onClick={() => setCommentModal(true)}
                                            >
                                                View Comments
                                            </button>
                                        )}
                                        <button className='blueBtn' type='submit' onClick={submitComment}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='btnContainer'>
                                <button className='btnSupport message' onClick={handleSendMessage}>
                                    <Message /> Send Message
                                </button>
                                {/* Refund and Cancel should be done by customer no option here  */}
                                {ticketData.status !== 'in_progress' && (
                                    <button className='btnSupport refund' onClick={() => handleUpdateTicket('open')}>
                                        <Refund /> Open Ticket
                                    </button>
                                )}
                                {ticketData.status !== 'resolved' && (
                                    <>
                                        <button className='btnSupport booking' onClick={() => setAssignModal(true)}>
                                            <CancelBooking /> Assign Ticket
                                        </button>
                                        <button
                                            className='btnSupport closeTicket'
                                            onClick={() => handleUpdateTicket('close')}
                                        >
                                            <CloseTicket /> Close Ticket
                                        </button>
                                    </>
                                )}
                            </div>
                            <div className='moreDetails'>
                                <MoreItem data={ticketData?.userId?.emailId} type='email' />
                                <MoreItem data={ticketData?.bookingId?.totalSeats} type='profile' />
                                <MoreItem data={ticketData?.userId?.phoneNumber} type='phone' />
                                <MoreItem data={ticketData?.packId?.title} type='location' />
                                <MoreItem data={data.bookingTime} type='calendar' />
                                <MoreItem data={ticketData?.bookingId?.amountPaid?.paid} type='price' />
                                <MoreItem data={ticketData?.packId?.title} type='place' />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {commentModal && (
                <Dialog openModal={commentModal} heading={'Comments'}>
                    <div className='dialogContent'>
                        <div className='mb-2'>
                            {ticketData.comments.map((item) => (
                                <div className='commentData'>
                                    <span>{item?.name} - </span>
                                    <span>{item?.at?.split('T')[0]}</span>
                                    <p>{item?.comment}</p>
                                </div>
                            ))}
                        </div>
                        <div className='alignCenter'>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setCommentModal(false);
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {descModal && (
                <Dialog openModal={descModal} heading={'Description'}>
                    <div className='dialogContent'>
                        <div className='commentForm'>
                            <textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder='Write your description...'
                            />
                        </div>
                        <div className='alignCenter'>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setDescModal(false);
                                    setDescription('')
                                }}
                            >
                                Close
                            </button>
                            <button className='dialogActBtn submit' onClick={handleUpdateTicket}>
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {assignModal && (
                <Dialog openModal={assignModal} heading={'Assign Ticket'}>
                    <div className='dialogContent'>
                        <select
                            name='type'
                            id='type'
                            className='select'
                            value={assignedUser}
                            onChange={(e) => setAssignedUser(e.target.value)}
                        >
                            <option value='Select'>Select</option>
                            {userList.map((item) => (
                                <option value={item._id} key={item._id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <div className='alignCenter'>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setAssignModal(false);
                                    setAssignedUser('')
                                }}
                            >
                                Close
                            </button>
                            <button className='dialogActBtn submit' onClick={handleAssigneeUpdate}>
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    );
};

export default SupTicketsDetails;
